import { render, staticRenderFns } from "./handleDataConfirm.vue?vue&type=template&id=31fc079a&scoped=true"
import script from "./handleDataConfirm.vue?vue&type=script&lang=js"
export * from "./handleDataConfirm.vue?vue&type=script&lang=js"
import style0 from "./handleDataConfirm.vue?vue&type=style&index=0&id=31fc079a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc079a",
  null
  
)

export default component.exports